import { format } from 'date-fns';

const source = String(process.env.SOURCE);

export class ReservationData {
    locationId: string;
    locationName: string;
    locationPhoneNumber: string;
    day: string;
    reservationId: string;
    emailAddress: string;
    firstName: string;
    lastName: string;
    mobileNumber: string;
    occasion: string;
    partySize: number;
    marketingOptIn: boolean;
    specialRequest: string;
    reservationArea: string;
    reservationDate: string;
    timeSlot: string;
    waitTime: string;
    source: string;
    conceptId?: string;
    callAhead: boolean;
    timesByArea: Array<{
        area: string;
        availableTimes: Array<string>;
    }>;
    metadata?: {
        eventId?: number;
        eventVersion?: number;
        eventSessionId?: number;
        skipPreTimeSlotLock?: boolean;
        externalSystemId?: string;
        reservationToken?: string;
        expiresAt?: string;
    };
    lastReservationInfo: {
        timeSlot: string;
        partySize: number;
        locationId: string;
    };

    public get startDateTime(): string {
        const now = new Date();
        return `${format(now, 'yyyy-MM-dd')}T${format(now, 'HH:mm')}`;
    }

    public set startDateTime(_: string) {
        // No-op: setter required for Object.assign compatibility
    }

    public get dateTime(): Date {
        if (!this.timeSlot) return new Date();
        return new Date(`${this.day}T${this.timeSlot}`);
    }

    public set dateTime(_: Date) {
        // No-op: setter required for Object.assign compatibility
    }

    constructor(init?: Partial<ReservationData>) {
        this.metadata = {
            externalSystemId: 'TWS',
            reservationToken: init?.metadata?.reservationToken,
        };
        Object.assign(this, init);
    }

    public GetReservationContract() {
        const contract: Partial<ReservationData> = {
            reservationId: this.reservationId,
            emailAddress: this.emailAddress,
            firstName: this.firstName,
            lastName: this.lastName,
            mobileNumber: this.mobileNumber,
            occasion: this.occasion,
            partySize: this.partySize,
            marketingOptIn: this.marketingOptIn,
            reservationDate: `${format(new Date(this.reservationDate), 'yyyy-MM-dd')}T00:00`,
            specialRequest: this.specialRequest || '',
            reservationArea: this.reservationArea || 'default',
            timeSlot: this.timeSlot,
            source: source,
            callAhead: this.callAhead,
            metadata: {
                eventId: this.metadata?.eventId,
                eventVersion: this.metadata?.eventVersion,
                eventSessionId: this.metadata?.eventSessionId,
                skipPreTimeSlotLock: this.metadata?.skipPreTimeSlotLock,
                externalSystemId: this.metadata?.externalSystemId,
                reservationToken: this.metadata?.reservationToken || '',
            },
            startDateTime: this.startDateTime,
        };

        return contract;
    }
}
